/**
 * Created by valerasiestov on 02.12.15.
 */


if (!window.module) {
    window.module = {};
}

module.imagePreview = (function (global) {
    "use strict";

    var controls = {},
        core = {
            loadImage: function (link) {
                return new Promise(function (fullFill, reject) {
                    var i = new Image();

                    i.onload = function () {
                        fullFill(i);
                    };

                    i.src = link;

                    if (i.complete) {
                        setTimeout(function () {
                            fullFill(i);
                        }, 1);
                    }

                });
            }
        },
        handlers = {
            previewClick: function () {
                var element = this,
                    link = element.getAttribute('data-preview'),
                    popupUrl = element.getAttribute('data-popup'),
                    text = element.querySelector('h2').innerHTML;

                if (element.classList.contains('loading')) {
                    return;
                }

                element.classList.add('loading');

                core.loadImage(link).then(function (image) {
                    element.classList.remove('loading');
                    module.popup.show({
                        url: popupUrl,
                        beforeShow: function (popup) {
                            document.body.classList.add('popup-scroll-fix');
                        },
                        afterClose: function () {
                            document.body.classList.remove('popup-scroll-fix');
                        },
                        handlers: {
                            popupClose: function (event) {

                                if (window.map && map.destroy) {
                                    window.map.destroy();
                                }

                                event.preventDefault();
                                document.body.classList.remove('popup-callback-visible');
                                this.hide();
                            },
                            popupWindowClick: function (event) {
                                event.stopPropagation();
                            }
                        }
                    }).then(function (data) {
                        var header;

                        var container = data.dom.querySelector('#image-container');
                        container.appendChild(image);
                        header = data.dom.querySelector('h2');

                        header.innerHTML = text;


                    });
                });
            }
        };

    function setEventList() {
        global.addEvents(controls.previewList, 'click', handlers.previewClick);
    }

    function getControls() {
        controls.previewList = document.querySelectorAll('[data-preview]');
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    module.imagePreview.init({

    });

}, false);
